export enum Event3sType {
  ResponseReceived = "ResponseReceived",
  ResultsRendered = "ResultsRendered",
  SearchEntityClicked = "SearchEntityClicked",
  SearchEntityActions = "SearchEntityActions",
  ClientLayout = "ClientLayout",
}
